const ResizeObserverProxy = new Proxy(window.ResizeObserver, {
  construct: (Target, args) => {
    const [callback] = args
    let isScheduled = false

    return new Target((entries) => {
      if (isScheduled) {
        return
      }

      isScheduled = true
      window.requestAnimationFrame(() => {
        isScheduled = false

        callback(entries)
      })
    })
  }
})

export const initResizeObserverPatcher = () => {
  window.ResizeObserver = ResizeObserverProxy
}
